/** @module SiteAdmin/SubtypedDataSheet */
define([
	"dojo/_base/declare",
	"csi/datasheet/Widget",
	"./SubtypedViewMixin"
], function(declare,DataSheetWidget,SubtypedViewMixin) {

	return declare([DataSheetWidget, SubtypedViewMixin], {
	});
});